export class UserUtil {
  /**
   *
   * @param {*} members
   * @returns {Array} Array of users
   * @example
   * const users = UserUtil.getUsersFromMembers({
   *   users: [
   *     { id: '1', name: 'John Doe' },
   *     { id: '2', name: 'Jane Doe' },
   *   ],
   *   groups: [
   *     { id: '3', name: 'Group 1', users: [{ id: '4', name: 'John Doe' }, { id: '5', name: 'Jane Doe' }] },
   *   ],
   * });
   */
  static getUsersFromMembers(
    members = {
      users: [],
      groups: [],
    },
  ) {
    let users = [];

    if (members.users) {
      const usersToAdd = members.users.map(user => ({
        ...user,
        hasGroup: false,
        groupId: null,
      }));
      users.push(...usersToAdd);
    }

    if (members.groups) {
      members.groups.forEach(group => {
        const groupUsers = group.users;
        const groupName = group.name;

        const usersToAdd = groupUsers.map(user => ({
          ...user,
          groupName,
          hasGroup: true,
          groupId: group.id,
        }));

        users.push(...usersToAdd);
      });
    }

    return users;
  }
}
